import { IComponentController } from 'angular';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageRc0007 extends IComponentController {
    formulaireTxm: IFormulaire;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    rciMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

interface IRc0007Params {
    id: number;
}

/* @ngInject */
export default function Rc0007Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemAction: IMenuItemActionClass,
    exDateFilter: IFilterExDate,
    MenuItemForage: IMenuItemForageClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    rc0001Route: IRoute,
    rc2002Route: IRoute,
    $stateParams: IRc0007Params) {
    const vm: IPageRc0007 = this;
    vm.valeursEcran = ecranDetails.valeurs;  
    const docTxm = [
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            rc0001Route.NAME,
            (data: any) => ({
                id: data.doccleintref
            }),
            {
                fonction: 'BOUDAC',
                icon: 'exit_to_app'
            }
        )
    ];

    vm.monoOccurrenceOptions = {
        infosMonetaires: {
            blocs: ['rci'],
            donnees:
                [
                    { nom: 'mnttot', libelle: 'LBL_MNT_TOT' }
                ]
        },
        menus: [
            new MenuItemForage(
                'G_LBL_CREA_RAP',
                rc2002Route.NAME, () => ({}),
                {
                    iconButton: false,
                    icon: 'subtitles',
                    secondaire: true
                }
            )
        ],
        formulaire: new Formulaire('LBL_BLC_TXM', [
            new FormulaireItem('txmnumdoc'),
            new FormulaireItem('txmnumdocseq'),
            new FormulaireItem('txmflgpij'),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('refcleint'),
            new FormulaireItem('doccleintref', { menu: docTxm }),
            new FormulaireItem('intcleintreq'),
            new FormulaireItem('intcleintdem'),
            new FormulaireItem('vectxmcat'),
            new FormulaireItem('peccleint', {
                 resourceParams: (data: any) => ({ txmdat: data.txmdat }),
                  readonly: !vm.valeursEcran.flgsaiperdec 
                 }),
            new FormulaireItem('txmdat', { default: exDateFilter(new Date()) }),
            new FormulaireItem('txmdatreq'),
            new FormulaireItem('txmdsc', { largeur: 66.66, enableCount: true })
        ], { largeurDefaut: 33.33 }
        )
    };

    // ligne
    vm.rciMultiOccurrenceOptions = {
        bloc: 'rci',
        editionRapideActive: true,
        fonctions: {
            editionRapide: true,
            editionStandard: true,
            boutonDupliquer: false
        },
        colonnesVisibles: [
            { nom: 'dailig', largeur: 100 },
            { nom: 'daidsc', largeur: 200 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'vecrciremsto_dsc', largeur: 150 },
            { nom: 'rcicom', largeur: 250 },
            { nom: 'vaercirem', largeur: 130 },
            { nom: 'vaercirem_dsc', largeur: 200 }
        ],
        colonnesFixesDroite: [
            { nom: 'rciprxuni', largeur: 120 },
            { nom: 'rciqtefor', largeur: 120 },
            { nom: 'rcimnttot', largeur: 120 },
            { nom: 'rciflgmsg', largeur: 100 }
        ],
        colonnesEditionRapide: [
            {
                nom: 'rciligref', largeur: 200,
                resourceParams: (data: any) => ({
                    doccleintref: data.$ancetre.doccleintref
                })
            },
            { nom: 'daidsc', largeur: 210 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'vecrciremsto', largeur: 210 },
            { nom: 'rcicom', largeur: 250 },
            { nom: 'vaercirem', largeur: 150 },
            { nom: 'rciprxuni', largeur: 120 },
            { nom: 'rciqtefor', largeur: 120 },
            { nom: 'rcimnttot', largeur: 120 },
            { nom: 'rcimsg', largeur: 200 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('rciligref', {
                largeur:33,
                resourceParams: (data: any) => ({
                    doccleintref: data.$ancetre.doccleintref
                })
            }),
            new FormulaireItem('daidsc',{
                 largeur:33,
            }),
            new FormulaireItem('rcimsg',{
                 largeur:33,
            }),
            new FormulaireItem('vecrciremsto', {
                largeur: 33 
            }),
            new FormulaireItem('rcicom', {
                largeur: 33 
            }),
            new FormulaireItem('vaercirem', {
                largeur: 33 
            }),
            new FormulaireItem('rciprxuni', {
                largeur: 33 
            }),
            new FormulaireItem('rciqtefor', {
                largeur: 33 
            }),
            new FormulaireItem('rciqte', {
                largeur: 33 
            }),
            new FormulaireItem('rcimnttot', {
                largeur: 33 
            })
        ])
    };

}
